import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material'
import { City, Country, State } from 'country-state-city';
import { useFormik } from 'formik';
import React, { useState } from 'react'
import { useAddAddressMutation } from '../../features/fullApi';
import { useSelector } from 'react-redux';

const CreateAddressDialog = ({openCreateAddress, setOpenCreateAddress, handleCreateAddress}) => {
  
  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }
  const [country, setCountry] = useState("")
  const [state, setState] = useState("")
  const [city, setCity] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const countries = Country.getAllCountries()
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])

  const handleChangeCountry = (e) => {
    setCountry(e)
    setStates(State.getStatesOfCountry(e.isoCode))
    setCountryCode(e.isoCode)
    setCity("")
  }

  const handleChangeState = (e) => {
    setState(e)
    setCities(City.getCitiesOfState(e.countryCode, e.isoCode))
    handleChangeCity(City.getCitiesOfState(e.countryCode, e.isoCode))
  }

  const handleChangeCity = (e) => {
    console.log("hcs", e)
    setCity(e)
  }

  const [addAddress] = useAddAddressMutation()

  const onSubmit = async (values, actions) => {
    console.log("called on submit")
    console.log("VALUES ON SUBMIT", values)
    addAddress({userId: user?._id, name: values.name, surname: values.surname, country: country.name,
      street: values.street, state: state.name, city:city.name, zipcode: values.zipcode, countryCode: countryCode}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      }).then(res => {
        console.log("RES.DATA", res)
      }
    ).catch(err => {
        console.log("ERR", err)
    })
  };


  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: "",
      surname: "",
      city: "",
      street: "",
      zipcode: "",
      region: "",
      country: "",
      countryCode: "",
    },
    onSubmit,
  });

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
     <Dialog aria-labelledby='dialog-title' onClose={() => setOpenCreateAddress(false)} open={openCreateAddress}>
     <DialogTitle id='dialog-title'>
          Create Address
    </DialogTitle>
    <DialogContent>
    <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
        id="name"
        type="text"
        value={values.name}    
        onChange={handleChange}
        onBlur={handleBlur}
        label="name"
        margin="dense"
      />
    </FormControl>
    {errors.name && touched.name && <p className="error">{errors.name}</p>}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="surname"
        type="text"
        margin="dense"
        value={values.surname}
        onChange={handleChange}
        onBlur={handleBlur}
        label="surname"
    />
    </FormControl>
    {errors.surname && touched.surname && (
      <p className="error">{errors.surname}</p>
    )}

<FormControl fullWidth style={{marginBottom: '10px'}}>
      <InputLabel>Country</InputLabel>
      <Select
        id="country"
        value={country}
        label="Country"
        onChange={(e) => handleChangeCountry(e.target.value)}
      >
          {countries?.map((option) => (
          <MenuItem key={option.name} value={option}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    {errors.country && touched.country && (
      <p className="error">{errors.country}</p>
    )}

  <FormControl fullWidth style={{marginBottom: '10px'}}>
      <InputLabel>State</InputLabel>
      <Select
        id="state"
        value={state}
        label="State"
        onChange={(e) => handleChangeState(e.target.value)}
      >
          {states?.map((option) => (
          <MenuItem key={option.name} value={option}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    {errors.state && touched.state && (
      <p className="error">{errors.state}</p>
    )}


  <FormControl fullWidth style={{marginBottom: '10px'}}>
      <InputLabel>City</InputLabel>
      <Select
        id="state"
        value={city}
        label="State"
        onChange={(e) => handleChangeCity(e.target.value)}
      >
          {cities.map((option) => (
          <MenuItem key={option.name} value={option}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    {errors.city && touched.city && (
      <p className="error">{errors.city}</p>
    )}

  <FormControl fullWidth style={{marginBottom: '10px'}}>
  <TextField
    id="street"
    type="text"
    margin="dense"
    value={values.street}
    onChange={handleChange}
    onBlur={handleBlur}
    label="street"
  />
  </FormControl>
    {errors.street && touched.street && (
      <p className="error">{errors.street}</p>
    )}


  <FormControl fullWidth style={{marginBottom: '10px'}}>
  <TextField
    id="zipcode"
    type="number"
    margin="dense"
    value={values.zipcode}
    onChange={handleChange}
    onBlur={handleBlur}
    label="zipcode"
  />
  </FormControl>
    {errors.zipcode && touched.zipcode && (
      <p className="error">{errors.zipcode}</p>
    )}

  <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
    id="countryCode"
    type="text"
    margin="dense"
    value={countryCode}
    onChange={handleChange}
    onBlur={handleBlur}
    label="Country Code"
    disabled
  />
  </FormControl>
    {errors.countryCode && touched.countryCode && (
      <p className="error">{errors.countryCode}</p>
    )}
    </DialogContent>
    <DialogActions>
              <Button
                  color="secondary"
                  onClick={() => {
                      setOpenCreateAddress(false)
                  }}
                  variant="contained"
              >Cancel</Button>
              <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                  onClick={() => {
                    values.state=state.name
                    values.country=country.name
                    values.city=city.name
                    values.countryCode=countryCode
                    handleCreateAddress(values)
                  }}
                  >Yes</Button>
                </DialogActions>
    </Dialog>
  </form>
  )
}

export default CreateAddressDialog